import { EntityField } from '~/jobiqo/models/entity';

/**
 * Get the vocabulary target from the field settings.
 *
 * @param {EntityField} field
 *   The field for which to get the taxonomy vocabularies from.
 */
export const getTaxonomyVocabularies = (field: EntityField): string[] => {
  const setting = field.settings.filter((i) => {
    return i.key === 'handler_settings';
  });
  if (setting.length > 0) {
    return Object.keys(setting[0].value.target_bundles);
  }
  return [];
};

/**
 * Get all children of a term.
 *
 * This function will get all children of a term and return an array with all the children ids.
 *
 * @param termId
 *  The term id to get all children from.
 *
 * @param terms
 *  The list of terms to search for children.
 *
 * @returns
 *  An array with all the children ids.
 */
export function getAllChildrenOfTerm(termId: string, terms: any[]) {
  const term = terms.find((t) => t?.code === termId);
  let termsToRemove: any[] = [];

  if (term?.code) {
    termsToRemove = [term.code];

    const children = terms.filter(
      (t) => t.parent?.tid.toString() === term.code,
    );

    if (children.length > 0) {
      // For each child hide its children.
      children.forEach((child) => {
        termsToRemove = [
          ...termsToRemove,
          ...getAllChildrenOfTerm(child.code, terms),
        ];
      });
    }
  }

  return termsToRemove;
}
